import { useQuery } from '@tanstack/react-query';
import { ContestApi } from 'api/ApiHelper';
import { contestsQueryKey } from 'queries/contests/queryKey';

export const useGetMyContestContentsQuery = (contestId: number) =>
  useQuery({
    queryKey: contestsQueryKey.myContestContents(contestId),
    queryFn: () => ContestApi.getMyContestContents(contestId),
    enabled: contestId > 0,
  });
